import { apiClient, endpoints } from '../api/client';

/** Definitions whose "being worked" marker a successful BrandTrax inject should clear. */
export function definitionIdsForWorkClear(
  taskDefinitionId?: string | null,
  matchedDefinitionId?: string | null
): string[] {
  return [
    ...new Set(
      [taskDefinitionId, matchedDefinitionId].filter((id): id is string => Boolean(id && id.trim()))
    ),
  ];
}

export async function clearDefinitionWorkStatuses(definitionIds: string[]): Promise<void> {
  await Promise.all(
    definitionIds.map(async definitionId => {
      try {
        await apiClient.put(endpoints.definitionWorkStatus(definitionId), { working_by: null });
      } catch (error) {
        console.warn(`Failed to clear work status for definition ${definitionId}`, error);
      }
    })
  );
}
